// This component allows users to create a new room or join an existing one by entering a room ID.
// It handles the creation of a new room and the joining of an existing room based on the provided room ID.
// It also handles the redirection to the room page after creating or joining a room.
// It uses the `useNavigate` hook from `react-router-dom` to navigate to the room page.

import React from 'react'
import {useNavigate} from "react-router-dom";

const IndexPage = () => {

    const navigate = useNavigate();
    const roomRef = React.useRef(null);

    const join = async (e) => {
        e.preventDefault()
        const room_id = roomRef.current.value;
        navigate(`/room/${room_id}`, { state: { id: room_id}})
    }  

    const create = async (e) => {
        e.preventDefault()

        console.log("Received request, querying service")
        const resp = await fetch("https://avsecure.vip:8443/create?cachebreaker=",
        {
          mode: 'cors',
        });
        const { room_id } = await resp.json();

        navigate(`/room/${room_id}`, { state: { id: room_id}})
    }    
  return (
    <div>
      <div>
        <label>
          To Create a AVSecure Chat, click the button here:
          <br/>
          <button onClick={create}> Create Room</button>
        </label>
      </div>
      <div>
        To join a room, enter the ID you were provided in the box below and click "Join Room"
        <br/>
        <label>
          Room ID: 
          <input name="room" ref={roomRef}></input>
        </label>
        <button onClick={join}> Join Room</button>
      </div>
</div>
  )
}

export default IndexPage